import { render, staticRenderFns } from "./ProfileInstagram.vue?vue&type=template&id=a4af4a88&"
import script from "./ProfileInstagram.vue?vue&type=script&lang=js&"
export * from "./ProfileInstagram.vue?vue&type=script&lang=js&"
import style0 from "./ProfileInstagram.vue?vue&type=style&index=0&id=a4af4a88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports